import { Inertia } from "@inertiajs/inertia";
//initial state
const state = () => ({
    url: "",
    notification: {
        title: "",
        msg: "",
        filled: false,
        success: false,
        error: false,
        warning: false,
        active: false,
      },
})

//getters
const getters = {}

// actions
const actions = {
    setUrl({commit, dispatch}, url) {
        Inertia.put('/url-drive', url, {
            onFinish: visit => {
                Inertia.visit(location.pathname, {
                    preserveState: false,
                    preserveScroll: true,
                });
            },
            onSuccess: visit => {
                // to-do -> poner notificacion
                commit('setNotification', {
                    title: "¡Edición exitosa!",
                    msg: "Se ha editado la fila seleccionada",
                    filled: true,
                    success: true,
                    active: true,
                    pagination: state.pagination,
                  }, {root: true});
                setTimeout(() => dispatch('closeNotification', {}, {root: true}), 5000);
            },
        })
    },
}

//mutations
const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}